import { create } from 'zustand';

interface AppState {
  searchQuery: string;
  activeTags: string[];
  setSearchQuery: (query: string) => void;
  toggleTag: (tag: string) => void;
  clearAll: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  searchQuery: '',
  activeTags: [],
  setSearchQuery: (query) => set({ searchQuery: query }),
  toggleTag: (tag) => set((state) => ({
    activeTags: state.activeTags.includes(tag)
      ? state.activeTags.filter((t) => t !== tag)
      : [...state.activeTags, tag],
  })),
  clearAll: () => set({ searchQuery: '', activeTags: [] }),
}));
